import { z } from "zod";
/** Aprovar/reprovar a etapa ativa de uma instância de workflow (FASE-06-T48). */
export const decideWorkflowStepSchema = z.object({
    comment: z.string().trim().max(1000).optional(),
});
//# sourceMappingURL=decide-workflow-step.js.map